import { BaseDTO } from './basedto';

export class PEAssignment extends BaseDTO {
    EngineerUserId: number;
    SourceTypeId: number;
    PartCategoryId: number;
    SupplierCode: string;
    SioCodeId: number | null;
    PartNumber: string;
    constructor() {
        super();
    }
}
